<template>
  <div
    class="tw-flex tw-items-center tw-py-6 tw-gap-6 hover:tw-bg-light dark:hover:tw-bg-dm-light tw-px-6"
  >
    <div
      class="tw-flex tw-items-center"
      :style="`width: ${columns[0].width}`"
    >
      {{ status.name }}
    </div>

    <div :style="`width: ${columns[1].width}`">
      {{ status.description }}
    </div>

    <div :style="`width: ${columns[2].width}`">
      {{ status.action_dates.length }}
    </div>

    <div :style="`width: ${columns[3].width}`">
      <div
        class="tw-flex tw-items-center tw-gap-2"
      >
        <i-button
          type="white"
          is-icon
          @click="isEditStatusDialogOpen = true"
        >
          <icon-edit />
        </i-button>
        <i-confirm-popover
          :cancel-text="$t('common.actions.cancel')"
          :submit-text="$t('common.actions.delete')"
          @submit="deleteActionDate"
        >
          <template #reference>
            <i-button
              type="white"
              is-icon
              class="tw-text-primary"
              :is-loading="isDeleting"
            >
              <icon-trash />
            </i-button>
          </template>
          <template #content>
            <div>
              {{ $t('adm.permits.statuses.delete_statuses_dialog.confirm_text') }}
              {{ status.name }}
            </div>
          </template>
        </i-confirm-popover>
      </div>
    </div>
    <EditPermitStatusDialog
      :is-open="isEditStatusDialogOpen"
      :status-id="status.id"
      @close="isEditStatusDialogOpen = false"
    />
  </div>
</template>

<script>

import { getValidationError } from '@/helpers';
import EditPermitStatusDialog
  from '@/components/Administration/PermitManagement/Statuses/EditPermitStatusDialog.vue';

export default {
  name: 'PermitStatusListItem',
  components: { EditPermitStatusDialog },
  props: {
    status: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isEditStatusDialogOpen: false,
      isDeleting: false,
    };
  },

  methods: {
    async deleteActionDate() {
      this.isDeleting = true;
      try {
        await this.$store.dispatch('v2/admin/cms/permitManagement/statuses/deleteStatus', this.status.id);
      } catch (e) {
        this.$message.error({
          message: this.$capitalize(e.response.data.message),
          showClose: true,
        });
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>
